window.onload = function() {
  const sliders = document.querySelectorAll('.product-recommendations__products, .collection-carousel__products-inner');

  sliders.forEach(slider => {
    const section = slider.closest('.section');
    const leftArrow = section.querySelector('.left-arrow, .carousel-prev');
    const rightArrow = section.querySelector('.right-arrow, .carousel-next');

    const product = slider.querySelector('.product-recommendations__product, .collection-carousel__product');
    const productsVisible = Math.floor(slider.clientWidth / product.offsetWidth);
    const scrollAmount = product.offsetWidth * productsVisible;

    function updateArrowStates() {
      const maxScrollLeft = Math.round(slider.scrollWidth - slider.clientWidth);
      if (Math.round(slider.scrollLeft) <= 0) {
        leftArrow?.classList.add('disabled');
      } else {
        leftArrow?.classList.remove('disabled');
      }

      if (Math.round(slider.scrollLeft) >= maxScrollLeft) {
        rightArrow?.classList.add('disabled');
      } else {
        rightArrow?.classList.remove('disabled');
      }

      if (slider.scrollWidth <= slider.clientWidth) {
        leftArrow?.classList.add('disabled');
        rightArrow?.classList.add('disabled');
      }
    }

    updateArrowStates();
    slider.addEventListener('scroll', updateArrowStates);

    leftArrow?.addEventListener('click', function () {
      if (!leftArrow.classList.contains('disabled')) {
        slider.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      }
    });

    rightArrow?.addEventListener('click', function () {
      if (!rightArrow.classList.contains('disabled')) {
        slider.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
    });
    window.addEventListener('resize', () => {
      const newProductsVisible = Math.floor(slider.clientWidth / product.offsetWidth);
      scrollAmount = product.offsetWidth * newProductsVisible;
      updateArrowStates();
    });
  });
};
  
